import React from 'react'

import styles from './style.module.scss'

interface MobileCardTextProps {
  text: string
  url?: string
}

export const MobileCardText: React.FC<MobileCardTextProps> = ({ text, url }) => {
  const hasLink = text.includes('here')

  if (!hasLink) {
    return <>{text}</>
  }

  return (
    <>
      {text.replace(' here', '')}{' '}
      {url ? (
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.linkText}
        >
          here
        </a>
      ) : (
        <span className={styles.linkText}>here</span>
      )}
    </>
  )
}